import { render, staticRenderFns } from "./ListPKBPage.vue?vue&type=template&id=43c548df&"
import script from "./ListPKBPage.vue?vue&type=script&lang=js&"
export * from "./ListPKBPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPKBPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports